export default {
      id: "action-icon-requested-usage",
      viewBox: "0 0 30 31",
      url: __webpack_public_path__ + "icons.svg#action-icon-requested",
      toString: function () {
        return this.url;
      }
    }